<template>
  <Modal variant="edit-email" @close="close">
    <template slot="lead">
      <span class="c-text--main">メールアドレスを変更します</span>
    </template>
    <template slot="content">
      <p class="l-mb-4">
        ご本人様確認のため、現在のパスワードを入力してください。
      </p>
      <div class="c-fieldset">
        <p class="c-fieldset__header">
          <span class="c-fieldset__title">変更後のメールアドレス</span>
        </p>
        <div class="c-fieldset__content">
          <p class="c-text--left">{{ newEmail }}</p>
        </div>
      </div>
      <div class="c-fieldset">
        <p class="c-fieldset__header">
          <span class="c-fieldset__title">現在のパスワード</span>
          <span class="c-required">必須</span>
        </p>
        <div class="c-fieldset__content c-alertPos">
          <InputPassword
            name="newPassword"
            v-model="params.password"
            placeholder=""
            :class="{ alert: isEdited.password && error.password }"
          />
          <Alert v-if="isEdited.password && error.password">
            {{ error.password }}
          </Alert>
        </div>
      </div>
      <Note>
        <ul class="c-list--disc">
          <li class="c-text--accent">
            メールアドレス変更後は、現在のメールアドレス({{
              email
            }})でのログインはできなくなります。
          </li>
          <li>
            変更後のメールアドレス({{
              newEmail
            }})に確認メールが届きます。<br />メールを確認し、記載されているURLにアクセスしてください。
          </li>
          <li>
            確認メールのURLにアクセスがなく5日が経過すると、メールアドレスの確認ができなくなります。<br />カスタマーサポート(<a
              :href="'mailto:' + $constants.customerSupportEmail"
              >{{ $constants.customerSupportEmail }}</a
            >)までご連絡ください。
          </li>
        </ul>
      </Note>
      <Checkbox
        id="agree"
        name="agree"
        v-model="params.agree"
        position="center"
        class="l-mt-4"
      >
        <div class="c-alertPos">
          上記の内容を確認し、メールアドレスを変更することに同意します。
          <Alert v-if="isEdited.agree && error.agree">
            {{ error.agree }}
          </Alert>
        </div>
      </Checkbox>

      <p class="c-text--accent c-text--center l-mt-2" v-if="errorResponse">
        {{ errorResponse }}
      </p>
      <Button
        variant="main"
        size="w230"
        fsize="f16"
        :disabled="isError || isProcessing"
        class="l-mt-5"
        :class="{ 'is-loading': isProcessing }"
        @click="submit"
      >
        変更する
      </Button>
    </template>
  </Modal>
</template>

<script>
import { AUTH0_CONFIG, ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Checkbox from '@/components/Checkbox';
import InputPassword from '@/components/InputPassword';
import Modal from '@/components/Modal';
import Note from '@/components/Note';
import apiUsers from '@/api/users';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  props: {
    email: {
      type: String,
      required: true
    },
    newEmail: {
      type: String,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Checkbox,
    InputPassword,
    Modal,
    Note
  },

  data() {
    return {
      error: {
        agree: '',
        password: ''
      },
      errorResponse: '',
      params: {
        agree: false,
        password: ''
      },
      isEdited: {
        agree: false,
        password: false
      },
      isError: false,
      isProcessing: false
    };
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.errorResponse = '';
      },
      deep: true
    },
    'params.agree': {
      handler(value, oldValue) {
        this.error.agree = new Validation().check().test(this.params.agree);
        if (typeof oldValue !== 'undefined') {
          this.isEdited.agree = true;
        }
      },
      immediate: true
    },
    'params.password': {
      handler(value, oldValue) {
        this.error.password = new Validation()
          .input()
          .test(this.params.password);
        if (typeof oldValue !== 'undefined') {
          this.isEdited.password = true;
        }
      },
      immediate: true
    }
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      const oldIdToken = this.auth.idToken;

      this.auth
        .checkPassword({
          email: this.email,
          password: this.params.password
        })
        .then(response => {
          let params = {
            email: this.newEmail
          };
          apiUsers.me
            .put(params, this.auth.idToken, oldIdToken)
            .then(response => {
              this.isProcessing = false;
              this.close();
              this.$store.dispatch('view/setLoading', true);

              let returnTo =
                AUTH0_CONFIG.returnTo.changeEmail +
                '?email=' +
                encodeURIComponent(this.newEmail);

              this.auth.logout(returnTo);
            })
            .catch(error => {
              if (error.response) {
                this.errorResponse = error.response.data.errors[0].userMessage;
              }
              this.isProcessing = false;
            });
        })
        .catch(error => {
          if (error.code === 'access_denied') {
            this.error.password = 'パスワードが間違っています';
          } else {
            this.errorResponse = ERROR_MESSAGE.auth0[error.code]
              ? ERROR_MESSAGE.auth0[error.code]
              : ERROR_MESSAGE.other;
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
